import {Component, Input} from "@angular/core";
import {AbstractControl, UntypedFormControl, Validators} from "@angular/forms";

@Component({
    selector: 'app-input-text',
    template: `
      <label class="text-xs m-0" [for]="name">{{ label ?? name + "_label" | i18next }}@if(isRequired){<span>*</span>}</label>
      <p-inputgroup>
        <ng-content select="[input-prefix]"></ng-content>
        <input class="w-full" [id]="name" type="text" pInputText [formControl]="formControl" [placeholder]="(placeholder | i18next)" [autoFocus]="autoFocus" [tabindex]="tabIndex" />
      </p-inputgroup>
      <app-input-error-message [control]="formControl" [name]="name"></app-input-error-message>
  `,
    styleUrls: [],
    standalone: false
})

export class InputText {
  @Input() control: AbstractControl | UntypedFormControl;
  @Input() name: string = '';
  @Input() label?: string;
  @Input() placeholder: string;
  @Input() disabled = false;
  @Input() autoFocus: boolean;
  @Input() tabIndex: number;

  get formControl() {
    return this.control as UntypedFormControl;
  }

  get isRequired() {
    return this.control.hasValidator(Validators.required);
  }
}